

import React, { useState, useEffect, useRef } from "react";
import './Management4.css';
import { FaTrash } from 'react-icons/fa';
import axios from 'axios';




const Management4 = () => {
  const [activeTab, setActiveTab] = useState('Customers');
  const [orders, setOrders] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const screenWidth = window.innerWidth;
  const [vendorId, setVendorId] = useState(null);
  const isMobile = window.innerWidth <= 768;
  const [processingOrderId, setProcessingOrderId] = useState(null);
  const containerHeight = window.innerWidth < 768
    ? '300px'       // Mobile
    : window.innerWidth < 850
      ? '300px'     // Below 850px
      : window.innerWidth < 1400
        ? '470px'   // Between 850px and 1399px
        : window.innerWidth < 1600
          ? '570px' // Between 1400px and 1599px
          : '670px'; // Above 1600px


  useEffect(() => {
    const storedVendorId = localStorage.getItem("vendorId");
    setVendorId(storedVendorId);
  }, []);

  useEffect(() => {
    const fetchOrders = async () => {
      if (!vendorId) return;

      const token = localStorage.getItem("authToken");
      if (!token) {
        console.warn("Authorization token is missing");
        return;
      }

      try {
        // ✅ Fetch WAITING_FOR_PICKUP orders using status-range API
        const response = await axios.get(
          `https://backend.maamaas.com/food/api/orders/status-range`,
          {
            params: {
              vendorId: vendorId,
              fromStatus: "WAITING_FOR_PICKUP",
              toStatus: "WAITING_FOR_PICKUP"
            },
            headers: { Authorization: `Bearer ${token}` }
          }
        );

        const waitingForPickupOrders = response.data || [];

        // ✅ Fetch TABLE_DINE_IN orders with PROCESSING items
        const confirmedRes = await axios.get(
          `https://backend.maamaas.com/food/api/cart/get/ordertype=TABLE_DINE_IN/${vendorId}/PROCESSING`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        // ✅ Combine both order sources
        const combinedOrders = [...waitingForPickupOrders, ...(confirmedRes.data || [])];

        // ✅ Sort orders by date (ascending - oldest first)
        combinedOrders.sort((a, b) => {
          const dateA = new Date(a.orderDateAndTime || a.createdAt || 0);
          const dateB = new Date(b.orderDateAndTime || b.createdAt || 0);
          return dateA - dateB; // Ascending order
        });

        // ✅ Deduplicate by cartId / orderId
        const uniqueOrders = combinedOrders.filter(
          (order, index, self) =>
            index ===
            self.findIndex(
              (o) =>
                (o.cartId && o.cartId === order.cartId) ||
                (o.orderId && o.orderId === order.orderId)
            )
        );

        setOrders(uniqueOrders);

      } catch (error) {
        console.error("Failed to fetch orders:", error.response?.data || error.message);
      }
    };

    fetchOrders();

    const intervalId = setInterval(fetchOrders, 10000);
    return () => clearInterval(intervalId);
  }, [vendorId]);





  const handleItemSelect = (orderId, index) => {
    setSelectedItems((prev) => {
      const existing = prev[orderId] || [];
      const updated = existing.includes(index)
        ? existing.filter((i) => i !== index)
        : [...existing, index];
      return { ...prev, [orderId]: updated };
    });
  };

  const handleSelectAll = (orderId, itemsLength) => {
    setSelectedItems((prev) => {
      const isAllSelected = prev[orderId]?.length === itemsLength;
      const newSelection = isAllSelected ? [] : [...Array(itemsLength).keys()];
      return { ...prev, [orderId]: newSelection };
    });
  };

  const [showDetails, setShowDetails] = useState(false);

  const orderStages = ["Accepted", "Delivered"];

  const styles = {
    card: { border: '1px solid #ccc', padding: '16px', marginTop: '10px', borderRadius: '10px', background: "linear-gradient(to right, #f46b45, #eea849)", },
    header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
    orderId: { margin: 0, fontWeight: "bold" },
    date: { fontSize: '18px', color: '#555', fontWeight: "bold" },
    pickupBtn: { background: '#28a745', color: '#fff', border: 'none', padding: '6px 12px', cursor: 'pointer', borderRadius: '5px', fontWeight: "bold", },
    tracker: { marginTop: '10px', display: 'flex', alignItems: 'center', fontWeight: "bold" },
    statusBox: { background: '#eee', padding: '8px 12px', borderRadius: '5px' },
    arrow: { margin: '0 5px' },
    dropdownBtn: {
      background: 'none',
      border: 'none',
      fontSize: '20px',
      cursor: 'pointer',
      ...(screenWidth >= 1000 && screenWidth <= 1200 ? { marginLeft: '80px' } : {}), // 👈 conditional style
    },
    itemList: { marginTop: '10px', fontWeight: "bold" },
    itemRow: { display: 'flex', justifyContent: 'space-between', padding: '4px 0', borderBottom: '1px solid #ddd' }
  };

  const handlePreparedClick = async (order) => {
    const token = localStorage.getItem("authToken");
    setProcessingOrderId(order.orderId || order.cartId);

    if (!token) {
      alert("Authorization token is missing");
      return;
    }

    try {
      if (order.orderType === "TABLE_DINE_IN") {
        // ✅ Update all cartItems to COMPLETED
        const status = "COMPLETED";
        const note = "Delivered successfully";

        if (!order.cartItems || order.cartItems.length === 0) {
          console.warn("No cart items found for this dine-in order");
          return;
        }

        const updatePromises = order.cartItems.map((item) =>
          axios.put(
            `https://backend.maamaas.com/food/api/cart/cartitem/status/${item.itemId}?status=${status}&note=${encodeURIComponent(note)}`,
            {},
            { headers: { Authorization: `Bearer ${token}` } }
          )
        );

        await Promise.all(updatePromises);
        //console.log("✅ All dine-in items marked as COMPLETED");

        // 🔄 Remove THIS order from the state instead of reloading
        setOrders(prevOrders =>
          prevOrders.filter(o => o.cartId !== order.cartId)
        );

      } else {
        // ✅ For normal orders, mark as DELIVERED
        if (!order.orderId) {
          console.warn("No orderId found for this order");
          return;
        }

        const response = await axios.put(
          `https://backend.maamaas.com/food/api/orders/edit-orders/${order.orderId}/DELIVERED`,
          { status: "DELIVERED" },  // Changed from COMPLETED to DELIVERED
          { headers: { Authorization: `Bearer ${token}` } }
        );

        //console.log("Order marked as DELIVERED:", response.data);

        // 🔄 Remove THIS order from the state instead of reloading
        setOrders(prevOrders =>
          prevOrders.filter(o => o.orderId !== order.orderId)
        );
      }
    } catch (error) {
      console.error("Failed to update order/cart items:", error.response?.data || error.message);
    } finally {
      setProcessingOrderId(null);
    }
  };







  // {=======================overview===============================}
  const tabContent = {
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      height: '78vh',
      marginTop: '30px'
    }}>

      {/* FIXED HEADER - Won't scroll */}
      <div style={{
        flexShrink: 0,
        padding: '0px',
        backgroundColor: '#ffffffff',
        zIndex: 100,
        borderBottom: '0px solid #ddd'
      }}>
        <div style={{ marginTop: "0px",padding:"1rem 1rem 0.5rem 1rem" }} className="p-44">
          <h2 style={{
            marginBottom: "0px",
            textAlign: 'center',
            fontWeight: '500',
           
          }}>Delivery Order Queue</h2>
        </div>
      </div>

      {/* SCROLLABLE CONTENT AREA - Only this part scrolls */}
      <div style={{
        flex: 1,
        overflowY: 'auto',
        scrollbarWidth: "thin"
      }} className="waiter-mobile-data">

        {/* Tab Buttons */}
        <div style={{
          gap: '10px',
          display: 'flex',
          justifyContent: 'space-evenly',
          margin: '0px 0'
        }}>
          {Object.keys(tabContent).map((label) => (
            <button
              key={label}
              onClick={() => setActiveTab(label)}
              style={{
                border: 'none',
                borderRadius: '10px',
                width: '100px',
                height: '40px',
                backgroundColor: activeTab === label ? '#b15cd6' : '#d9d9d9',
                color: '#000',
                fontWeight: 'bold',
                cursor: 'pointer',
                transition: 'background-color 0.3s ease',
              }}
            >
              {label}
            </button>
          ))}
        </div>

        {/* Orders Content - This is the scrollable part */}
        <div style={{
          padding: '0 16px',
          paddingBottom: '20px'
        }}>
          {orders.length === 0 ? (
            <div style={{
              textAlign: 'center',
              padding: '40px',
              fontSize: '18px',
              color: '#666',
              fontWeight: 'bold',
              backgroundColor: '#ffffffff',
              borderRadius: '8px',
              margin: '20px'
            }}>
              No orders available at the moment
            </div>
          ) : (
            orders.map((order) => {
              // ✅ Use cartItems for TABLE_DINE_IN, otherwise order.order
              const orderItems =
                order.orderType === "TABLE_DINE_IN" ? order.cartItems || [] : order.order || [];

              const orderId = order.orderId || order.cartId; // fallback
              const selected = selectedItems[orderId] || [];

              return (
                <div key={orderId} style={{
                  border: '1px solid #ccc',
                  padding: '16px',
                  margin: '16px',
                  marginRight: window.innerWidth < 769 ? "16px" : "0px",
                  marginBottom: '16px',
                  borderRadius: '10px',
                  background: (() => {
                    const normalized = (order.orderType || "").trim().toLowerCase();
                    switch (normalized) {
                      case "dine_in": return "#1E90FF";
                      case "takeaway": return "#FF6347";
                      case "delivery": return "#20B2AA";
                      case "table_dine_in": return "#2051b2ff";
                      default: return "#b15cd6";
                    }
                  })(),
                }}>
                  <div style={styles.header}>
                    <div style={{
                      display: 'flex',
                      flexDirection: window.innerWidth < 1300 ? 'column' : 'row',
                      justifyContent: 'space-between',
                      alignItems: window.innerWidth < 1300 ? 'stretch' : 'center',
                      gap: window.innerWidth < 1300 ? '10px' : '0',
                      width: '100%',
                      padding: '5px 0',
                    }}>

                      {/* First Line: Order ID and Date/Time */}
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: window.innerWidth <= 500 ? 'start' : 'center',
                        width: '100%',
                        flexDirection: window.innerWidth <= 500 ? "column" : "row",
                        marginLeft: window.innerWidth <= 370 ? "-1rem" : " ",
                        gap: window.innerWidth <= 370 ? '0px' : '10px',
                        padding: window.innerWidth < 1300 ? '0 5px' : '0',
                      }}>
                        <div style={{
                          ...styles.orderId,
                          margin: 0,
                          fontSize: window.innerWidth <= 370 ? '14px' : '17px',
                          fontWeight: 'bold',
                          color: "black",
                          whiteSpace: 'nowrap',
                          display: "flex",
                          justifyContent: "space-between", // This pushes children to opposite ends
                          alignItems: "center",
                          width: "100%", // Ensure it takes full width
                        }}>
                          {/* Left side - Order ID */}
                          <div style={{
                            flex: "0 0 auto", // Don't grow, don't shrink, auto width
                          }}>
                            ORDER ID : <span style={{
                              fontSize: window.innerWidth <= 500 ? "1rem" : "1.3rem",
                              color: "white"
                            }}>#{orderId}</span>
                          </div>

                          {/* Right side - Order Type button */}
                          <div style={{
                            flex: "0 0 auto", // Don't grow, don't shrink, auto width
                            marginLeft: "10px", // Add some spacing from Order ID
                          }}>
                            <button style={{
                              background: '#28a745',
                              color: '#fff',
                              border: 'none',
                              padding: window.innerWidth < 1100 ? "5px 10px" : '6px 15px',
                              borderRadius: '4px',
                              fontWeight: 'bold',
                              fontSize: '14px',
                              whiteSpace: 'nowrap',
                              cursor: 'default',
                              display: window.innerWidth <= 450 ? "block" : "none",
                            }}>
                              {order.orderType === 'DINE_IN' ? 'DINEIN' : (order.service || order.orderType || 'Service')}
                            </button>
                          </div>
                        </div>

                        {/* Date and Time inline */}
                        {order.orderDateAndTime && (
                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            fontSize: window.innerWidth <= 370 ? '14px' : '16px',
                            color: '#000000ff',
                            fontWeight: '500',
                            whiteSpace: 'nowrap',
                          }}>
                            <span style={{ whiteSpace: 'nowrap' }}>
                              {(() => {
                                const dateObj = new Date(order.orderDateAndTime);
                                const date = dateObj.toLocaleDateString('en-IN', {
                                  day: '2-digit',
                                  month: 'short',
                                  year: 'numeric',
                                });
                                const time = dateObj.toLocaleTimeString('en-IN', {
                                  hour: '2-digit',
                                  minute: '2-digit',
                                  hour12: true,
                                });
                                return (
                                  <>
                                    <span style={{ color: '#000000ff', fontWeight: 'bold', fontSize: window.innerWidth <= 370 ? '14px' : '17px', }}>DATE:</span>
                                    <span style={{ color: '#ffffffff', marginRight: '10px', marginLeft: "5px", fontSize: window.innerWidth <= 500 ? "1rem" : "1.3rem" }}>{date}</span>
                                    <span style={{ color: '#000000ff', fontWeight: 'bold', fontSize: window.innerWidth <= 370 ? '14px' : '17px', }}>TIME:</span>
                                    <span style={{ color: '#ffffffff', marginLeft: "5px", fontSize: window.innerWidth <= 500 ? "1rem" : "1.3rem" }}>{time}</span>
                                  </>
                                );
                              })()}
                            </span>
                            <button
                              style={{
                                background: 'none',
                                border: '0px solid #ccc',
                                borderRadius: '4px',
                                padding: '6px 12px',
                                cursor: 'pointer',
                                fontSize: '14px',
                                minWidth: '40px',
                                display: window.innerWidth > 1299 ? "none" : "block",
                              }}
                              onClick={() =>
                                setShowDetails((prev) => ({
                                  ...prev,
                                  [orderId]: !prev[orderId],
                                }))
                              }
                            >
                              {showDetails[orderId] ? '▲' : '▼'}
                            </button>
                          </div>

                        )}
                      </div>

                      {/* Second Line: Order Type, Status, and Dropdown */}
                      <div style={{
                        display: 'flex',
                        justifyContent: window.innerWidth < 1300 ? 'flex-end' : 'end',
                        alignItems: 'center',
                        gap: window.innerWidth >= 1300 && window.innerWidth < 1350 ? '5px' : '15px',
                        width: '100%',
                        padding: window.innerWidth < 1300 ? '5px 5px 0 5px' : '0',
                        flexWrap: 'wrap',
                      }}>
                        {/* Order Type */}
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                        }}>
                          <button style={{
                            background: '#28a745',
                            color: '#fff',
                            border: 'none',
                            padding: '6px 15px',
                            borderRadius: '4px',
                            fontWeight: 'bold',
                            fontSize: '14px',
                            whiteSpace: 'nowrap',
                            cursor: 'default',
                            display: window.innerWidth > 450 ? "block" : "none",
                          }}>
                            {order.orderType === 'DINE_IN' ? 'DINEIN' : (order.service || order.orderType || 'Service')}
                          </button>
                        </div>


                        {/* Dropdown button */}
                        <button
                          style={{
                            background: 'none',
                            border: '0px solid #ccc',
                            borderRadius: '4px',
                            padding: '6px 12px',
                            cursor: 'pointer',
                            fontSize: '14px',
                            minWidth: '40px',
                            display: window.innerWidth > 1299 ? "block" : "none",
                          }}
                          onClick={() =>
                            setShowDetails((prev) => ({
                              ...prev,
                              [orderId]: !prev[orderId],
                            }))
                          }
                        >
                          {showDetails[orderId] ? '▲' : '▼'}
                        </button>
                      </div>
                    </div>
                  </div>

                  {showDetails[orderId] && (
                    <>
                      <div style={{ marginTop: window.innerWidth < 450 ? '-1rem' : '0rem', margin: window.innerWidth < 768 ? "0px 0%" : window.innerWidth >= 1200 ? " 0px 30%" : "0px 15%" }}>
                        {/* Table with invisible styling */}
                        <table style={{
                          width: '100%',
                          borderCollapse: 'collapse',
                          border: 'none',
                          background: 'transparent'
                        }}>
                          {/* Table Header - invisible */}
                          <thead>
                            <tr style={{
                              border: 'none',
                              background: 'transparent'
                            }}>
                              <th style={{
                                textAlign: 'center',
                                color: 'black',
                                fontWeight: 'bold',
                                fontSize: window.innerWidth <= 370 ? '14px' : '17px',
                                padding: '8px 10px',
                                paddingBottom: '0px',
                                border: 'none',
                                background: 'transparent'
                              }}>
                                ITEM
                              </th>
                              <th style={{
                                textAlign: window.innerWidth < 450 ? 'center' : 'center',
                                color: 'black',
                                fontWeight: 'bold',
                                fontSize: window.innerWidth <= 370 ? '14px' : '17px',
                                padding: '8px 10px',
                                paddingBottom: '0px',
                                border: 'none',
                                background: 'transparent'
                              }}>
                                QUANTITY
                              </th>
                            </tr>
                          </thead>

                          {/* Table Body - invisible */}
                          <tbody>
                            {orderItems
                              .filter((item) => item.status === "Okay" || item.orderType === "TABLE_DINE_IN")
                              .map((item, index) => (
                                <tr
                                  key={index}
                                  style={{
                                    border: 'none',
                                    background: 'transparent'
                                  }}
                                >
                                  {/* Item column with checkbox */}
                                  <td style={{
                                    padding: '0px 20px',
                                    paddingTop: '0px',
                                    border: 'none',
                                    background: 'transparent',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px'
                                  }}>
                                    <input
                                      type="checkbox"
                                      checked={!!selectedItems[item.listId || item.id || index]}
                                      onChange={() => {
                                        const id = item.listId || item.id || index;
                                        setSelectedItems(prev => ({
                                          ...prev,
                                          [id]: !prev[id]
                                        }));
                                      }}
                                      style={{
                                        cursor: 'pointer',
                                        marginRight: '20px'
                                      }}
                                    />
                                    <span style={{
                                      fontSize: window.innerWidth <= 500 ? "1rem" : "1.3rem",
                                      color: '#ffffffff'
                                    }}>
                                      {item.dishName}
                                    </span>
                                  </td>

                                  {/* Quantity column */}
                                  <td style={{
                                    padding: '8px 10px',
                                    paddingTop: '0px',
                                    border: 'none',
                                    background: 'transparent',
                                    textAlign: window.innerWidth < 450 ? 'center' : 'center',
                                    fontWeight: 'bold',
                                    fontSize: window.innerWidth <= 500 ? "1rem" : "1.3rem",
                                    color: '#ffffffff'
                                  }}>
                                    {item.quantity || 1}
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </>
                  )}

                  {/* Order Stages */}
                  {/* Order Stages */}
                  <div
                    style={{
                      ...styles.tracker,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {Array.isArray(orderStages) &&
                      orderStages.map((stage, index) => {
                        // Check if TABLE_DINE_IN order has any item in PROCESSING
                        const isDineInProcessing =
                          order.orderType === "TABLE_DINE_IN" &&
                          order.cartItems?.some((i) => i.orderStatus === "PROCESSING");

                        // Highlight "Accepted" for PROCESSING TABLE_DINE_IN orders
                        const isDineInAccepted = isDineInProcessing && stage === "Accepted";

                        // Normal orders
                        const isNormalOrderAccepted = order.status === "CONFIRMED" && stage === "Accepted";
                        const isNormalOrderReady = order.status === "WAITING_FOR_PICKUP" && stage === "Delivered";

                        return (
                          <React.Fragment key={index}>
                            <div
                              onClick={async () => {
                                if (isDineInProcessing || isNormalOrderReady) {
                                  await handlePreparedClick(order);
                                }
                              }}
                              style={{
                                ...styles.statusBox,
                                backgroundColor:
                                  order.orderType === "TABLE_DINE_IN"
                                    ? (isDineInAccepted || isNormalOrderAccepted || isNormalOrderReady
                                      ? "green"
                                      : "#f0f0f0")
                                    : (order.status === "WAITING_FOR_PICKUP" && stage === "Accepted") ||
                                      (order.status === "COMPLETED" && stage === "Delivered")
                                      ? "green"
                                      : "#f0f0f0",

                                color:
                                  order.orderType === "TABLE_DINE_IN"
                                    ? (isDineInAccepted || isNormalOrderAccepted || isNormalOrderReady
                                      ? "white"
                                      : "black")
                                    : (order.status === "WAITING_FOR_PICKUP" && stage === "Accepted") ||
                                      (order.status === "COMPLETED" && stage === "Delivered")
                                      ? "white"
                                      : "black",

                                borderRadius: "6px",
                                padding: "8px 12px",
                                fontWeight: "bold",
                                textTransform: "uppercase",

                                cursor:
                                  order.orderType === "TABLE_DINE_IN"
                                    ? (isDineInProcessing || isNormalOrderReady ? "pointer" : "default")
                                    : stage === "Delivered" && order.status === "WAITING_FOR_PICKUP"
                                      ? "pointer"
                                      : "default",
                              }}

                            >
                              {stage}
                            </div>
                            {index !== orderStages.length - 1 && <span style={styles.arrow}></span>}
                          </React.Fragment>
                        );
                      })}
                  </div>

                </div>
              );
            })

          )}





        </div>


      </div>
    </div>
  );
};



export default Management4;

